import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./Steps.css";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from '@mui/material';
import dayjs from 'dayjs';

import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import EventAvailableRoundedIcon from '@mui/icons-material/EventAvailableRounded';
import EventRoundedIcon from '@mui/icons-material/EventRounded';
import ContactPhoneRoundedIcon from '@mui/icons-material/ContactPhoneRounded';
import AddToCalendar from "../../common/AddToCalendar";
import NavToAddress from "../../common/NavToAddress";
import { useT } from "../../../i18n";


function Step6(props) {
  const location = useLocation();
  const t = useT();
  const { user } = useSelector((state) => state.auth)
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const department = user?.departments.find(d => d.id == props.formData.department_id)
  const doctor = props.formData.doctor || {};

  // calendar event body: pre-visit instructions + the provider's phone/email (NOT sent in the SMS).
  const calDetails = [
    props.formData.timeData?.note || '',
    doctor.phone ? t('appointment.calendarPhone', { phone: doctor.phone }) : '',
    doctor.email ? t('appointment.calendarEmail', { email: doctor.email }) : '',
  ].filter(Boolean).join('\n');

  const Next = () => {
    // Go to the clean home URL explicitly. navigate(-1) was fragile: if the user reached
    // /form via a refresh or a direct link (no '/' in history), "back" wouldn't return home
    // and the address bar stayed stuck on /form.
    navigate('/');
  }

  return (
    <div className="step step5 step6-final">
      <div className="s6-success">
        <span className="s6-check"><CheckCircleRoundedIcon /></span>
        <h3 className="s6-title">{t("step6.title")}</h3>
        {/* ★ שני מפתחות ולא שרשור: בערבית/רוסית הפסיק והסדר אחרי-השם שונים,
            והרכבת המשפט בקוד הייתה מקבעת את התחביר העברי. */}
        <p className="s6-sub">
          {props?.formData.fname
            ? t("step6.subWithName", { name: props.formData.fname })
            : t("step6.sub")}
        </p>
      </div>

      <div className="s6-cards">

        {/* פרטי התור */}
        <div className="s6-card">
          <div className="s6-card-head"><EventAvailableRoundedIcon fontSize="small" /> {t("step6.apptDetails")}</div>
          <div className="s6-card-body">
            <div className="s6-provider">
              <span className="s6-dept">{department?.title}</span>
              {doctor.title && <><span className="s6-sep">·</span><span>{doctor.title}</span></>}
            </div>
            <div className="s6-dt">
              <div className="s6-dt-box"><span>{t("common.date")}</span><b>{dayjs(props.formData.timeData.wdate).format('DD/MM/YYYY')}</b></div>
              <div className="s6-dt-box"><span>{t("common.time")}</span><b>{props.formData.timeData.start_time.slice(0, -3)}</b></div>
            </div>
          </div>
        </div>

        {/* הוספה ליומן */}
        <div className="s6-card">
          <div className="s6-card-head"><EventRoundedIcon fontSize="small" /> {t("step6.addToCalendar")}</div>
          <div className="s6-card-body s6-card-body--cal">
            <AddToCalendar
              title={t('appointment.calendarEventTitle', {
                title: `${department.title}${props?.formData?.doctor?.title ? ' - ' + props.formData.doctor.title : ''}`,
              })}
              start={dayjs(props.formData.timeData.wdate).format('YYYY-MM-DD') + 'T' + props.formData.timeData.start_time.slice(0, 5)}
              durationMinutes={props.formData.timeData.duration || 15}
              location={props?.formData?.doctor?.address || ''}
              details={calDetails}
            />
          </div>
        </div>

        {/* פרטי נותן השירות — כמו במסך ההנחיות */}
        {(doctor.phone || doctor.email || doctor.address) && (
          <div className="s6-card">
            <div className="s6-card-head"><ContactPhoneRoundedIcon fontSize="small" /> {t("step6.providerDetails")}</div>
            <div className="s6-card-body">
              <NavToAddress
                bare
                showAddress={true}
                address={doctor.address || ''}
                phone={doctor.phone || ''}
                email={doctor.email || ''}
                location={doctor.location || ''}
              />
            </div>
          </div>
        )}
      </div>

      <Button variant="contained"
        className="next-btn" onClick={Next}>{t("step6.finishAndBack")}</Button>

    </div>
  );
}

export default Step6;
